module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tracking_parcel":"Tracking Parcel","order_received":"Order received"},"id":{"tracking_parcel":"Paket Pelacakan","order_received":"Pesanan diterima"}}')
  delete Component.options._Ctor
}
